import { Grid, Paper } from '@mui/material';
import { CustomerHistory } from '@nice-ccf/ui-components';
import ContactHistoryCard from './contact-history-card/contact-history-card';
import InteractionsHistoryCard from './interactions-history-card/interactions-history-card';
import classes from './simulator.module.scss';

/**
 * To show the contact detail for the selected contact from the contact list card. This will also let user to edit the values for the contact detail
 * @param props - it will take selected contact detail, and onchange hadnler
 * @returns
 * @example
 */
const AgentHistoryCard = (props: {
  selectedContact: any;
  agentHistoryList: CustomerHistory[] | undefined;
  handleInputChangeForAgentHistory: (
    id: any | undefined,
    field: string,
    value: string
  ) => void;
  handleInputChangeForHistory: (
    id: any | undefined,
    field: string,
    modifedtags: any,
    isFromContactHistory?: boolean
  ) => void;
  handleInputChangeForInteractionHistory: (
    id: any | undefined,
    field: string,
    value: any
  ) => void;
}) => {
  const { selectedContact } = props;

  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <ContactHistoryCard
          contactHistoryList={props.selectedContact?.contactHistoryList}
          handleInputChangeForHistory={props.handleInputChangeForHistory}
        />

        <InteractionsHistoryCard
          interactionHistoryList={props.selectedContact?.interactionHistoryList}
          handleInputChangeForInteractionHistory={
            props.handleInputChangeForInteractionHistory
          }
          selectedContact={selectedContact}
        />
      </Paper>
    </Grid>
  );
};

export default AgentHistoryCard;
